// src/pages/servicos/ordensServico/OrdemServicoFiltroAvancadoModal.js
import React, { useEffect, useState } from 'react';
import Input from '../../../components/input/Input';
import ModalBody from '../../../components/modalForm/ModalBody';
import ModalContainer from '../../../components/modalForm/ModalContainer';
import ModalFooter from '../../../components/modalForm/ModalFooter';
import ModalHeader from '../../../components/modalForm/ModalHeader';
import { useProduto } from '../../../contexts/produtos/ProdutoContext';
import {
  CAMPOS_FILTRO_AVANCADO_OS,
  OrdemServicoFiltroAvancado,
} from '../../../models/servicos/OrdemServicoFiltroAvancado';

const OrdemServicoFiltroAvancadoModal = ({ show, filtros, loading, onHide, onApply }) => {
  const { showProdutoSearch } = useProduto();
  const [dados, setDados] = useState(() => new OrdemServicoFiltroAvancado());
  const [erroProduto, setErroProduto] = useState(null);

  useEffect(() => {
    if (show) {
      setDados(new OrdemServicoFiltroAvancado(filtros));
      setErroProduto(null);
    }
  }, [show, filtros]);

  const alterar = (campo, valor) => {
    setDados(anteriores => ({ ...anteriores, [campo]: valor }));
    if (campo === 'produtoId') setErroProduto(null);
  };

  const buscarProduto = async () => {
    const produto = await showProdutoSearch();
    if (produto?.id) alterar('produtoId', String(produto.id));
  };

  const limpar = () => {
    setDados(new OrdemServicoFiltroAvancado());
    setErroProduto(null);
  };

  const aplicar = () => {
    const novosFiltros = new OrdemServicoFiltroAvancado(dados);
    const erro = novosFiltros.validar();
    if (erro) {
      setErroProduto(erro);
      return;
    }
    onApply(novosFiltros);
  };

  return (
    <ModalContainer show={show} largura="650px" variant="busca" onHide={onHide}>
      <ModalHeader title="Filtro avançado de ordens de serviço" onHide={onHide} />
      <ModalBody>
        <p className="text-muted mb-2">
          Todos os campos preenchidos serão considerados junto com os filtros da tela.
          Os textos pesquisam por trecho; os critérios de produto/serviço devem corresponder ao mesmo item.
        </p>
        <div className="row g-2">
          {CAMPOS_FILTRO_AVANCADO_OS.map(({ campo, label }) => (
            <div className="col-12" key={campo}>
              <Input
                label={label}
                value={dados[campo]}
                size={campo === 'produtoId' ? 140 : '100%'}
                autoFocus={campo === 'problemaRelatado'}
                inputMode={campo === 'produtoId' ? 'numeric' : undefined}
                maxLength={campo === 'produtoId' ? 10 : undefined}
                msgErro={campo === 'produtoId' ? erroProduto : undefined}
                btnBuscar={campo === 'produtoId' ? buscarProduto : undefined}
                onChange={evento => alterar(campo, campo === 'produtoId'
                  ? evento.target.value.replace(/\D/g, '')
                  : evento.target.value)}
              />
            </div>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-outline-secondary" onClick={limpar}>
          Limpar campos
        </button>
        <button type="button" className="btn btn-secondary" onClick={onHide}>
          Cancelar
        </button>
        <button type="button" className="btn btn-primary" disabled={loading} onClick={aplicar}>
          Aplicar e buscar
        </button>
      </ModalFooter>
    </ModalContainer>
  );
};

export default OrdemServicoFiltroAvancadoModal;
